import { apiFetch } from "../base";

export function * getTokenRefresh () {
	return yield apiFetch({
		endpoint: "/auth/v1/auth/refresh",
		method: "GET",
		authenticated: true
	});
}
